<template>
    <div>
        <div
            :style="{
                'background-color': player.headerColor,
                'border-bottom-color': player.borderColor,
            }"
            class="relative h-16 bg-white flex justify-between items-center px-5 sm:px-12 py-3 border-b"
        >
            <div class="flex items-center space-x-3">
                <cUtilsEdit @edit="goToLayoutField('playerLogo')">
                    <img height="40px" v-if="player.logo" class="h-10" :src="player.logo" />
                </cUtilsEdit>
                <div v-for="item in leftHeaders" :key="'dleft' + item.id">
                    <HeaderButton v-if="item.type === PLAYER_HEADER_TYPES.button" :item="item" />
                    <HeaderLink v-if="item.type === PLAYER_HEADER_TYPES.link" :item="item" />
                    <HeaderText v-if="item.type === PLAYER_HEADER_TYPES.text" :item="item" />
                </div>
            </div>
            <div class="flex items-center space-x-4">
                <div v-for="item in rightHeaders" :key="'dright' + item.id">
                    <HeaderButton v-if="item.type === PLAYER_HEADER_TYPES.button" :item="item" />
                    <HeaderLink v-if="item.type === PLAYER_HEADER_TYPES.link" :item="item" />
                    <HeaderText v-if="item.type === PLAYER_HEADER_TYPES.text" :item="item" />
                </div>
            </div>
            <!-- Mobile menu button-->
            <button
                @click="setMenuOpen(!menuOpen)"
                type="button"
                class="inline-flex lg:hidden items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
            >
                <span class="sr-only">Open main menu</span>

                <MenuRightIcon v-if="!menuOpen" class="h-6 w-6" />
                <XIcon v-else class="h-6 w-6" />
            </button>
        </div>
        <!-- Mobile menu -->
        <div
            v-if="menuOpen"
            :style="{ 'background-color': player.backColor }"
            class="block lg:hidden z-50 w-full absolute top-18 left-0 shadow"
        >
            <div v-if="leftHeaders.length + rightHeaders.length" class="px-2 pt-2 pb-3 space-y-2">
                <a
                    :style="{
                        color: item.type == 'button' ? player.mainColor : player.textColor,
                    }"
                    :href="item.href"
                    @click.prevent="goToLink(item.href)"
                    class="block font-medium cursor-pointer p-2"
                    v-for="item in leftHeaders"
                    :key="'mleft' + item.id"
                >
                    {{ item.name }}
                </a>
                <a
                    :style="{
                        color: item.type == 'button' ? player.mainColor : player.textColor,
                    }"
                    :href="item.href"
                    @click.prevent="goToLink(item.href)"
                    class="block font-medium cursor-pointer p-2"
                    v-for="item in rightHeaders"
                    :key="'mright' + item.id"
                >
                    {{ item.name }}
                </a>
            </div>
            <PlayerSidebar />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { MenuRightIcon, XIcon } from "@easy/ui/icons";
import HeaderButton from "./HeaderButton.vue";
import HeaderLink from "./HeaderLink.vue";
import HeaderText from "./HeaderText.vue";
import PlayerSidebar from "./PlayerSidebar.vue";
import { PLAYER_HEADER_TYPES, PLAYER_HEADER_SIDES } from "@/apps/player/services/players.service";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "PlayerHeader",
    components: {
        HeaderButton,
        HeaderLink,
        HeaderText,
        XIcon,
        MenuRightIcon,
        PlayerSidebar,
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToLayoutField } = usePlayerGoTo();
        return {
            goToLayoutField,
            goToLink,
        };
    },
    data() {
        return {
            PLAYER_HEADER_TYPES,
        };
    },
    computed: {
        ...mapState("player/view", ["player", "menuOpen"]),
        leftHeaders() {
            return this.player.headers.filter(
                (x) => x.side === PLAYER_HEADER_SIDES.left && !x._deleted
            );
        },
        rightHeaders() {
            return this.player.headers.filter(
                (x) => x.side === PLAYER_HEADER_SIDES.right && !x._deleted
            );
        },
    },
    methods: {
        ...mapMutations("player/view", ["setMenuOpen"]),
    },
};
</script>
